import type { NotificationChainTokenProps } from './Notifications.types';
import type { ReactElement } from 'react';

import React from 'react';

import styles from './Notifications.module.css';

const FALLBACK_IMAGE = '/imgs/coins/unknown.png';

export function NotificationChainToken(props: NotificationChainTokenProps): ReactElement {
  const { tokenImage, chainImage } = props;

  return (
    <span className={styles.chainToken}>
      <img className={styles.tokenImage} src={tokenImage || FALLBACK_IMAGE} alt="" />
      <img className={styles.chainImage} src={chainImage || FALLBACK_IMAGE} alt="" />
    </span>
  );
}
